<ng-template #filterTemplate>
  <div
    class="customer-filter-modal"
    role="dialog"
    aria-label="Filtro por franquia"
  >
    <div class="title-filter">
      <strong>{{ titleKey | translate }}</strong>
    </div>
    <div class="a-search-input -light-mode">
      <mat-form-field style="flex: 1">
        <input
          matInput
          (keydown.enter)="onApply()"
          id="text-input-3"
          [formControl]="searchControl"
          [placeholder]="placeholderText | translate"
        />
        <button
          *ngIf="searchControl.value"
          mat-icon-button
          matSuffix
          type="button"
          (click)="onResetSearch()"
          aria-label="Clear search"
        >
          <mat-icon fontIcon="bosch-ic-close"></mat-icon>
        </button>
        <button
          *ngIf="!searchControl.value"
          mat-icon-button
          matSuffix
          type="button"
          (click)="onApply()"
          aria-label="Search"
        >
          <mat-icon fontIcon="bosch-ic-search"></mat-icon>
        </button>
      </mat-form-field>
    </div>
    <div class="customer-list-scroll">
      <mat-checkbox
        *ngFor="let option of filteredOptions; trackBy: trackById"
        [checked]="isSelected(option)"
        (change)="toggleSelection(option)"
      >
        {{ option.label }}
      </mat-checkbox>
    </div>
    <hr />
    <div class="row-fx-legacy">
      <button
        class="generic-icon-neutral-button"
        mat-button
        (click)="onClear()"
      >
        <mat-icon class="icon-button" fontIcon="bosch-ic-refresh"></mat-icon>
        <p>{{ "label-clear-filter" | translate }}</p>
      </button>
      <button
        type="button"
        mat-raised-button
        color="primary"
        (click)="onApply()"
      >
        {{ "label-apply" | translate }}
      </button>
    </div>
  </div>
</ng-template>
